import { getConfig } from '../config';
import { logger } from './Loggers';
import { debugLogger } from './Loggers/DebugLogger';

// tslint:disable:no-console
const silentLogger = {
  notify: (e: Error) => {
    // no op
  },
  leaveBreadcrumb: (message: string) => {
    // no op. todo: maybe use breadcrumbCheck here to log warnings (even if "silent")
  },
  debug: (message: string, data: any) => {
    // no-op
  },
  setUser: (userId: string) => {
    // no op
  },
  clearUser: () => {
      // no op
  },
};

const localLogger = getConfig().useDebugLogger ? debugLogger : silentLogger;
export const Logger = __DEV__ ? localLogger : logger;
